import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { finalize } from 'rxjs';
import { appActions } from '@store/actions/app.actions';
import { isExcluded } from '@core/interceptors/interceptors.config';

/**
 * Token could be string, boolean or undefined.
 * - If it's undefined, no loading will be shown
 * - If it's boolean, the general loading will display hiding everything behind it.
 * - If it's a string, the corresponding <ac-loading-will-be-shown>
 */
export const LOADING_CXT_TOKEN = new HttpContextToken<boolean | string | undefined>(() => undefined);

const generalLoading = String(Math.random() * 997 * 977);
const loadingMap = new Map<string, number>([[generalLoading, 0]]);

const createOrAddCount = (key: string): void => {
  const value = loadingMap.get(key);
  if (value == null) {
    loadingMap.set(key, 1);
  } else {
    loadingMap.set(key, value + 1);
  }
};

const subtractCount = (key: string): number => {
  let value = loadingMap.get(key);
  if (value == null || value === 0) {
    value = 0;
  } else {
    value--;
  }
  loadingMap.set(key, value);
  return value;
};

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (isExcluded(req.url)) {
    return next(req);
  }
  const store: Store<StoreState> = inject(Store<StoreState>);
  const loadingContext = req.context.get(LOADING_CXT_TOKEN);
  if (typeof loadingContext == 'boolean' && loadingContext) {
    createOrAddCount(generalLoading);
    store.dispatch(appActions.showLoading());
    return next(req).pipe(
      finalize(() => {
        if (subtractCount(generalLoading) === 0) {
          store.dispatch(appActions.hideLoading());
        }
      })
    );
  } else if (typeof loadingContext == 'string') {
    createOrAddCount(loadingContext);
    store.dispatch(appActions.showCustomLoading({ loading: loadingContext }));
    return next(req).pipe(
      finalize(() => {
        if (subtractCount(loadingContext) === 0) {
          store.dispatch(appActions.hideCustomLoading({ loading: loadingContext }));
        }
      })
    );
  }
  return next(req);
};
